import React, { useEffect, useState } from 'react'

import User from '@js/common/user'
import { getTestParam, staticAsset } from '@js/common/utils'

import LocationFinderBVer from '@f/components/LocationFinder'
import LocationFinderBackup from '@f/components/LocationFinder/LocationFinderBackup'
import CTA from '@f/elements/CTA'
import Icon from '@f/elements/Icon'
const isBVersionTest = getTestParam('NR-10472_maps_api_v2') === 'B'
const LocationFinder = isBVersionTest
  ? LocationFinderBVer
  : LocationFinderBackup

const RegionalPricesInfo = props => {
  const [active, setActive] = useState(!!User.getLocation().postcode)

  useEffect(() => {
    _wt({
      category: 'modal',
      action: 'display',
      values: [
        {
          type: 'name',
          value: 'bauort-regional'
        }
      ]
    })
  }, [])

  const closeOverlay = () => {
    _wt({
      category: 'modal',
      action: 'hide',
      values: [
        {
          type: 'name',
          value: 'bauort-regional'
        }
      ]
    })

    props.closeModal()
  }

  return (
    <div className='[ f-d-flc f-c-ba-whi ] RegionalPricesInfo-container'>
      <CTA
        type='icon'
        tag='button'
        className='Modal-top-button Modal-top-button-close'
        onClick={closeOverlay}
        data-sel='btn-cls'>
        <Icon icon='close-16px' className='[ f-icon-030 f-c-st-bla ]' />
      </CTA>
      <div className='[ f-c-ba-neu025 f-c-fo-pri ] RegionalPricesInfo-bauort-container'>
        <div className='[ f-m-v-040 f-g-flc f-p-h-010 ]'>
          <div className='[ f-t-tsection f-c-fo-pri f-m-b-010 ] RegionalPricesInfo-center'>
            Jetzt Bauort anpassen!
          </div>
          <div className='[ f-m-b-020 f-m-h-020 f-t-body f-c-fo-pri f-t-centre ]'>
            Hauspreise sind regional unterschiedlich, passen Sie jetzt Ihren
            Bauort für verbesserte Preisangaben an.
          </div>
          <div className='[ f-d-flr ] RegionalPricesInfo-center RegionalPricesInfo-bauort'>
            <LocationFinder
              className='[ f-d-inbl ] RegionalPricesInfo-input'
              onChange={() => setActive(true)}
            />
            <CTA
              tag='button'
              type='block-primary'
              id='regional-prices-modal-cta'
              className={`[ f-p-a-020 ] RegionalPricesInfo-submit ${
                active ? '' : 'is-disabled'
              }`}
              onClick={active && closeOverlay}>
              Übernehmen
            </CTA>
          </div>
        </div>
      </div>
      <div className='[ f-m-t-040 f-p-h-020 f-p-b-040 ] RegionalPricesInfo-guide-container'>
        <div className='RegionalPricesInfo-guide'>
          <div className='[ f-m-b-020 ] RegionalPricesInfo-step'>
            <img
              src={staticAsset('images/at_f/regional-prices-example-blue.png')}
              loading='lazy'
            />
            <div className='[ f-t-body f-t-bold f-m-t-030 f-c-fo-ter ]'>
              Regionaler Preis
            </div>
            <div className='[ f-t-mini f-m-t-010 f-c-fo-pri ]'>
              Diese Preise werden blau angezeigt. Sobald Sie Ihren Bauort
              eingegeben haben erhalten Sie eine genauere Preisangabe zu Ihrer
              Region.
            </div>
          </div>
          <div className='[ f-m-b-020 ] RegionalPricesInfo-step'>
            <img
              src={staticAsset('images/at_f/regional-prices-example.png')}
              loading='lazy'
            />
            <div className='[ f-t-body f-t-bold f-m-t-030 f-c-fo-pri ]'>
              Nationaler Standardpreis
            </div>
            <div className='[ f-t-mini f-m-t-010 f-c-fo-pri ]'>
              Schwarz gefärbte Preise zeigen den nationalen Preis. In diesem
              Fall haben Sie noch keinen Bauort eingegeben oder wir haben keinen
              lokalen Preis von dem Anbieter erhalten.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RegionalPricesInfo
